export default {
  chosenCategory: async function () {
    this.sortDirection = 1;
    this.orderBy = "count";
    await this.FilterByAbuseCategory();
    this.orderData();
    this.maxCount = this.getMaxAbuseCount();
    await window.setTimeout(() => this.setCountBarLength(), 50);
  },

  orderCategory: async function () {
    const dataColumns = ["none", "count", "name", "sport"];

    this.orderBy = dataColumns[Math.abs(this.orderCategory)];
    this.sortDirection = Math.sign(this.orderCategory);

    await this.FilterByAbuseCategory();
    this.orderData();
    this.maxCount = this.getMaxAbuseCount();
    await window.setTimeout(() => this.setCountBarLength(), 50);
  },
};
